import {useState, useEffect} from "react"
import {useUser} from "@/contexts/UserContextProvider"
import supabase from "@/supabaseConfig"

/**
 * Custom hook to provide organization information
 *
 * @returns Organization data including orgId
 */
export function useOrganization() {
  const [orgName, setOrgName] = useState<string>("")
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)
  const {orgId, user} = useUser()

  useEffect(() => {
    if (!orgId) {
      setLoading(false)
      return
    }

    let isMounted = true

    const fetchOrgInfo = async () => {
      try {
        setLoading(true)

        // Direct Supabase query to organizations table
        const {data, error} = await supabase
          .from("organizations")
          .select("name")
          .eq("org_id", orgId)
          .single()

        if (error) {
          console.warn("Error fetching organization info:", error.message)
          setOrgName(`Organization (${orgId.slice(0, 8)}...)`)
        } else if (isMounted && data) {
          setOrgName(data.name || `Organization (${orgId.slice(0, 8)}...)`)
        }
      } catch (err) {
        console.error("Error in useOrganization:", err)
        if (isMounted) {
          setOrgName(`Organization (${orgId.slice(0, 8)}...)`)
        }
      } finally {
        if (isMounted) {
          setLoading(false)
        }
      }
    }

    fetchOrgInfo()

    return () => {
      isMounted = false
    }
  }, [orgId])

  return {
    orgName,
    orgId,
    loading,
    error,
  }
}
